import { render } from "./CartSmall.vue?vue&type=template&id=03ab71be"
import script from "./CartSmall.vue?vue&type=script&lang=js"
export * from "./CartSmall.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__